<template>
	<div class="TooltipInfoContainer">
		<i
			class="lnr-info Icon"
			@mouseenter="displayTooltip(true)"
			@mouseleave="displayTooltip(false)"
		/>
		<div
			class="TooltipContainer"
			:class="{isActiveTooltip: isActive}"
		>
			<div class="Tooltip">
				<!-- eslint-disable-next-line -->
				<p v-html="tooltipMessage" />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Tooltip",
	props: {
		tooltipMessage:{
			type: String,
			default: 'Something went wrong, please try again later.'
		}
	},
	data: function(){
		return {
			isActive: false,
		}
	},
	methods:{
		displayTooltip(condition) {
			this.isActive = condition;
		},
	}
};
</script>

<style lang="scss" scoped>
@import '../styles/main';

.Position{
	display: inline-block;
	vertical-align: middle;
	width: 1rem;
}

.TooltipInfoContainer{
	display: inline-block;
	vertical-align: middle;

	.Icon{
		@include FontSize(SN);
		vertical-align: middle;
		color: $GreyD;
		cursor: pointer;
	}

	.TooltipContainer{
		display: none;

		&.isActiveTooltip{
			display: block;
			text-align: left;
		}
	}

	.Tooltip{
		@include FontSize('SN');

		position: absolute;
		padding: 0.5rem;
		margin-top: 1rem;
		margin-left: -8rem;

		width: 17.25rem;
		z-index: $FourthFloor;

		background-color: $YellowLL;
		box-shadow: 0 0.25rem 0.3333rem 0 $Grey;
		border: 0.08rem solid $GreyL;

		&:before {
			display: block;
			position: absolute;
			content: ' ';

			top: -0.5rem;
			left: calc(50% - 0.5rem);
			margin-left: -0.8rem;

			height: 0.8rem;
			width: 0.8rem;
			transform: rotate(45deg);

			background-color: $YellowLL;
			border-top: 1px solid $GreyL;
			border-left: 1px solid $GreyL;
		}
	}
}
</style>
